import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { sizes, templates } from '../tornado/poster/poster.constants';
import { BLOCK_GAP } from './exploreCatalogue.constants';

export const createBlock = (color, screenSize, colorMode) => ({
  rect: true,
  flexItem: { marginRight: BLOCK_GAP[screenSize] },
  ...sizes[templates.PosterS][RENDERING_CONTEXT.GENERAL][screenSize],
  color: color[colorMode],
});
